





























































































































































































































































































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import Modal from '@/components/Modal'
import Gallery from '@ui/Gallery'
import Timeline from '@modules/ui/components/Timeline'
import SuperNotes from '@modules/ui/notes/SuperNotes'
import RequestButton from '@/components/RequestButton'
import FormField from '@ui/FormBuilder/FormField'
import RecapHeader from '@ui/Recap/RecapHeader'
import RecapUtility from '@utils/RecapUtility'

settings =
  name: 'RecapEdit'

  resources:
    recap:
      resourceName: 'recap'
      slug: 'recaps/:recapId'
      fetch: false
    recaps:
      resourceName: 'recaps'
      slug: 'recaps'
      infinityScroll: true
      fetch: false
    organizers:
      resourceName: 'organizers'
      slug: 'suppliers/:supplier.id/organizers'
      fetch: false
      params:
        limit: 1000

  vue:
    components: {
      LoadingIndicator,
      Modal,
      Gallery,
      Timeline,
      SuperNotes,
      RequestButton,
      FormField,
      RecapHeader,
    }

    data: ->
      show: true
      isLoading: false

      newRecapContact:
        first_name: null
        last_name: null
        email: null
        phone: null
      selectedRecapContact: null
      recapContactCollapse: ['select']

      galleryModal:
        show: false
        idx: 0

      publishModal:
        show: false

    mounted: ->
      if !@recap
        @fetchRecap()
      else
        @fetchOrganizers()

    computed:
      recapId: ->
        @$route.params.recapId
      previousRecapId: ->
        index = @recaps?.findIndex((r) => r.id is @recapId)
        @recaps?[index - 1]?.id
      nextRecapId: ->
        index = @recaps?.findIndex((r) => r.id is @recapId)
        @recaps?[index + 1]?.id

      supplier: ->
        @ctxSupplierOrg @recap

      recapContacts: ->
        contacts = {}

        for contact in @recap?.contacts || []
          if contact.level is 'venue'
            contacts[contact.email] = contact
          else
            contacts[contact.email] ||= contact

        Object.values contacts

      dueDate: ->
        return '' unless @recap.end_date and @recap.grace_period
        dayjs(@recap.end_date.slice(0, 10)).add(@recap.grace_period, 'day')

      totalRequiredQuestions: ->
        questions = RecapUtility.requiredQuestions @recap
        Object.keys(questions).length

      totalRequiredAnswers: ->
        answers = RecapUtility.requiredAnswers @recap
        Object.keys(answers).length

      totalValidPhotos: ->
        RecapUtility.validPhotos(@recap).length

      missingPhotos: ->
        Math.max(@recap.num_required_photos - @totalValidPhotos, 0)

      missingQuestions: ->
        Math.max(@totalRequiredQuestions - @totalRequiredAnswers, 0)

      availableRecapContacts: ->
        current = @pluck @recapContacts || [], 'email'
        list = @organizers || []
        list.filter((item) => item.email not in current)

    methods:
      onLoadItemCompleted: (resourceKey) ->
        if resourceKey is 'recap'
          @isLoading = false
          @fetchOrganizers()

      saveRecap: ->
        @saveItem 'recap'

      onSave: ->
        @fetchRecap()

      fetchRecap: ->
        @fetch 'recap'

      fetchOrganizers: ->
        @fetch 'organizers'

      hiSave: ->
        @saveRecap()

      hiUpload: (data) ->
        @uploadCompleted data
        @fetchRecap()

      hiPublish: ->
        @triggerResource 'recap', 'publish'
        @publishModal.show = false

      hiUnpublish: ->
        @triggerResource 'recap', 'unpublish'

      hiUnsubmit: ->
        @triggerResource 'recap', 'unsubmit'

      hiPublishConfirmModal: ->
        @publishModal.show = true

      hiEditTemplate: ->

      hiOpenGalleryImage: (index) ->
        @galleryModal.idx = index
        @galleryModal.show = true

      hiSelectPhoto: (photo) ->
        @selectPhoto photo
        @saveRecap()

      hiUnselectPhoto: (photo) ->
        @resetPhoto photo
        @saveRecap()

      hiInvalidPhoto: (photo) ->
        @invalidPhoto photo
        @saveRecap()

      hiUninvalidPhoto: (photo) ->
        @resetPhoto photo
        @saveRecap()

      hiSelectAnswer: (key) ->
        answers = JSON.parse(JSON.stringify(@recap.published_answers))
        answers[key] = @recap.answers[key]
        @recap.published_answers = answers
        @saveRecap()

      hiUnselectAnswer: (key) ->
        answers = JSON.parse(JSON.stringify(@recap.published_answers))
        delete answers[key]
        @recap.published_answers = answers
        @saveRecap()

      uploadCompleted: (data) ->
        payload = { urls: data.images }
        payload.options = data.options if data.options?
        @triggerResource 'recap', 'upload_completed', payload
      onRecapUploadCompleted: ->
        @fetchRecap()

      selectPhoto: (photo) ->
        @resetPhoto photo
        @recap.published_photos.push photo

      invalidPhoto: (photo) ->
        @resetPhoto photo
        @recap.photos_invalid.push photo

      resetPhoto: (photo) ->
        @recap.published_photos = @recap.published_photos.filter((url) => url isnt photo)
        @recap.photos_invalid = @recap.photos_invalid.filter((url) => url isnt photo)

      canSelectAnswer: (key) ->
        answers = RecapUtility.answers @recap
        return false unless answers[key]?
        return false unless @recap.question_template[key].component in ['textarea']
        true

      isAnswerPublished: (key) ->
        @recap.published_answers[key]?

      displayQuestion: (question) ->
        RecapUtility.displayQuestion question, @recap.answers

      hiTabSelectRecapContact: ->
        @recapContactCollapse = ['select']

      hiTabCreateRecapContact: ->
        @recapContactCollapse = ['create']

      hiSelectRecapContact: (email) ->
        @triggerResource 'recap', 'add_recap_contact', { email }

      hiCreateRecapContact: ->
        @triggerResource 'recap', 'add_recap_contact', @newRecapContact

      onRecapAddRecapContact: (payload, recap) ->
        @selectedRecapContact = null
        @newRecapContact[key] = null for key of @newRecapContact
        @forceRecapReactivity recap

      hiRemoveRecapContact: (email) ->
        @triggerResource 'recap', 'remove_recap_contact', { email }

      onRecapRemoveRecapContact: (payload, recap) ->
        @forceRecapReactivity recap

      forceRecapReactivity: (recap) ->
        @recap[key] = value for key, value of recap

      hiNavToPrevRecap: ->
        @navToRecap @previousRecapId
        @scrollTo '.recap-edit > div'
        @isLoading = true
        @fetchRecap()
      hiNavToNextRecap: ->
        @navToRecap @nextRecapId
        @scrollTo '.recap-edit > div'
        @isLoading = true
        @fetchRecap()
      navToRecap: (recapId) ->
        @$router.replace { name: 'RecapEditPage', params: { recapId } }

    watch:
      show: (show) ->
        @$router.back() unless show

export default VueOptions.vue settings
